import React from "react";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button } from "reactstrap";
import { t } from "i18next";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import { getDeliverables, deleteDeliverable } from "../../../api/deliverable";

export default function DealDeliverable({ dealId }) {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const role = currentUser.role || currentUser.roleName || {};

  const hasPermission = (action) => {
    if (role.name === "super admin") return true;
    return (
      role.permissions &&
      role.permissions.some(
        (perm) => perm.resource === "Sales" && perm.actions.includes(action)
      )
    );
  };

  const canEdit = () => hasPermission("update");
  const canDelete = () => hasPermission("delete");
  const canRead = () => hasPermission("update") || hasPermission("delete");

  const {
    response,
    loading,
    error,
    setPage,
    page,
    totalPages,
  } = usePagination(getDeliverables, { dealId }, Boolean(dealId));

  const handleDelete = async (id) => {
    if (window.confirm(t("Are you sure you want to delete this deliverable?"))) {
      try {
        await deleteDeliverable(id);
        setPage(1);
      } catch (err) {
        console.error("Delete failed:", err);
        alert(t("Failed to delete deliverable."));
      }
    }
  };

  if (!canRead()) {
    return <div>{t("You do not have permission to view deliverables.")}</div>;
  }

  return (
    <div className="mt-4">
      {response && response.length > 0 && !loading ? (
        <>
          {/* <Breadcrumbs
            title={`${t("Deliverable")} ${t("Table")}`}
            addUrl={dealId ? `/deliverables/add/${dealId}` : null}
            hasAddBtn={canCreate()}
          /> */}
          <CustomTable
            emptyMsg={t("No deliverables found.")}
            data={response}
            loading={loading}
            error={error}
            cols={[
              {
                label: t("Timeline"),
                key: "timeline",
                style: { width: "20%" },
              },
              {
                label: t("Deliverable"),
                key: "deliverable",
                style: { width: "20%" },
              },
              {
                label: t("Notes"),
                key: "notes",
                style: { width: "30%" },
                renderer: (row) => row.notes || "-",
              },
              {
                label: t("Actions"),
                key: "actions",
                style: { width: "30%" },
                renderer: (row) => (
                  <div className="d-flex gap-2">
                    {canEdit() && (
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => navigate(`/deliverables/edit/${row._id}`)}
                      >
                        {t("Edit")}
                      </Button>
                    )}
                    {canDelete() && (
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleDelete(row._id)}
                      >
                        {t("Delete")}
                      </Button>
                    )}
                  </div>
                ),
              },
            ]}
          />
          <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} />
        </>
      ) : (
        !loading && <div>{t("No results found.")}</div>
      )}
    </div>
  );
}
